// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const hideStack = defineModel({
  id: "hide-stack",
  batchId: "future",
  name: "Hide stack",
  tags: ["scenery","hide","stack","low-poly","age-of-mcp","future"],
  summary: "Stacked raw hides — the tannery's feed for leather.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.46, 0.05, 0.32), color: "#8a6a48", position: [-0.012, 0.025, -0.006], rotation: [0, -0.02, 0] },
      { geometry: new THREE.BoxGeometry(0.448, 0.05, 0.31), color: "#7c5e40", position: [-0.008, 0.075, 0.006], rotation: [0, 0.02, 0] },
      { geometry: new THREE.BoxGeometry(0.436, 0.05, 0.3), color: "#977552", position: [-0.004, 0.125, -0.006], rotation: [0, -0.02, 0] },
      { geometry: new THREE.BoxGeometry(0.424, 0.05, 0.29), color: "#7c5e40", position: [0, 0.175, 0.006], rotation: [0, 0.02, 0] },
      { geometry: new THREE.BoxGeometry(0.412, 0.05, 0.28), color: "#8a6a48", position: [0.004, 0.225, -0.006], rotation: [0, -0.02, 0] },
      { geometry: new THREE.BoxGeometry(0.4, 0.05, 0.27), color: "#977552", position: [0.008, 0.275, 0.006], rotation: [0, 0.02, 0] },
    ],
  animations: [],
});
